<h1>This is a Test Dialog</h1>

<p>Here is some test dialog content. To show a dialog, use <code>shell.showDialog(DialogComponentClass)</code>.
  Also be sure to implement the <code>pageComponentId()</code> method on your dialog component and set the 
  same name as the return value. This helps for server-side rendering should the dialog be included in a 
  server-side rendered page.
</p>

<p>To close a dialog from within it, use <code>close()</code>. The button 
  below uses this method to close the dialog. Elsewhere you can close any active 
dialog using <code>shell.hideDialog()</code>.</p>

<strong>The message that was included with this dialog invocation was:</strong><br/>
{{message}}

<h1>Additional Content to Induce Scrolling</h1>
<p>Fugiat voluptas odit molestiae non eos dignissimos voluptatem. Odio quia aut hic autem. Temporibus quae laboriosam corporis quo asperiores. Dolorem perferendis at sequi inventore occaecati inventore dolore. Eius deleniti voluptates ipsa quo aut voluptas quidem adipisci. Ad voluptatum impedit illo dolorem.</p>

<p>Delectus voluptatem facere eos commodi impedit. Non velit culpa non. Veritatis et in omnis laborum aperiam eos. Earum iusto corrupti omnis natus nemo sed.</p>

<p>Sunt debitis in numquam. Alias rerum nisi ut aut nisi molestiae nihil. Et eum omnis quod. Officiis expedita unde quaerat. Ut ut accusantium est illum molestiae.</p>

<p>Sint cumque asperiores dolorem blanditiis veniam. Incidunt sed eum aut reiciendis mollitia enim voluptatem. Qui neque voluptatem nobis cumque et itaque. Sed iste et quidem autem.</p>

<p>Inventore similique nihil ut sed aut suscipit ipsam necessitatibus. Error maiores magnam nesciunt aliquid dolor sit neque. Quasi tempore veniam modi. Dicta assumenda alias est. Optio molestias aperiam distinctio.</p>

<p>Fugiat voluptas odit molestiae non eos dignissimos voluptatem. Odio quia aut hic autem. Temporibus quae laboriosam corporis quo asperiores. Dolorem perferendis at sequi inventore occaecati inventore dolore. Eius deleniti voluptates ipsa quo aut voluptas quidem adipisci. Ad voluptatum impedit illo dolorem.</p>

<p>Delectus voluptatem facere eos commodi impedit. Non velit culpa non. Veritatis et in omnis laborum aperiam eos. Earum iusto corrupti omnis natus nemo sed.</p>

<p>Sunt debitis in numquam. Alias rerum nisi ut aut nisi molestiae nihil. Et eum omnis quod. Officiis expedita unde quaerat. Ut ut accusantium est illum molestiae.</p>

<p>Sint cumque asperiores dolorem blanditiis veniam. Incidunt sed eum aut reiciendis mollitia enim voluptatem. Qui neque voluptatem nobis cumque et itaque. Sed iste et quidem autem.</p>

<p>Inventore similique nihil ut sed aut suscipit ipsam necessitatibus. Error maiores magnam nesciunt aliquid dolor sit neque. Quasi tempore veniam modi. Dicta assumenda alias est. Optio molestias aperiam distinctio.</p>

<p>Fugiat voluptas odit molestiae non eos dignissimos voluptatem. Odio quia aut hic autem. Temporibus quae laboriosam corporis quo asperiores. Dolorem perferendis at sequi inventore occaecati inventore dolore. Eius deleniti voluptates ipsa quo aut voluptas quidem adipisci. Ad voluptatum impedit illo dolorem.</p>

<p>Delectus voluptatem facere eos commodi impedit. Non velit culpa non. Veritatis et in omnis laborum aperiam eos. Earum iusto corrupti omnis natus nemo sed.</p>

<p>Sunt debitis in numquam. Alias rerum nisi ut aut nisi molestiae nihil. Et eum omnis quod. Officiis expedita unde quaerat. Ut ut accusantium est illum molestiae.</p>

<p>Sint cumque asperiores dolorem blanditiis veniam. Incidunt sed eum aut reiciendis mollitia enim voluptatem. Qui neque voluptatem nobis cumque et itaque. Sed iste et quidem autem.</p>

<p>Inventore similique nihil ut sed aut suscipit ipsam necessitatibus. Error maiores magnam nesciunt aliquid dolor sit neque. Quasi tempore veniam modi. Dicta assumenda alias est. Optio molestias aperiam distinctio.</p>

<br/>
<br/>
<button class="btn btn-primary" (click)="close()">Close</button>